// Layout-Stil-Switch zwischen "juuplan-Komfort" (neuer Default — luftige Zeilen
// mit Pill-Status und Range-Datum) und "juuplan-Kompakt" (Fallback — die alte
// dichte Variante mit gefüllten Status-Cells). In localStorage persistiert und
// als data-attribute an document.documentElement gespiegelt, damit CSS bei
// Bedarf ohne Re-Render umschalten kann.

import { signal } from "@preact/signals";

export type LayoutStyle = "komfort" | "kompakt";

const STORAGE_KEY = "juuplan:layout";

const layoutSignal = signal<LayoutStyle>("komfort");

export function applyLayout(choice: LayoutStyle): void {
  layoutSignal.value = choice;
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-layout", choice);
}

export function loadLayout(): LayoutStyle {
  if (typeof localStorage === "undefined") return "komfort";
  const raw = localStorage.getItem(STORAGE_KEY);
  return raw === "kompakt" ? "kompakt" : "komfort";
}

export function saveLayout(choice: LayoutStyle): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(STORAGE_KEY, choice);
  applyLayout(choice);
}

export function useLayout(): LayoutStyle {
  return layoutSignal.value;
}

export function bootstrapLayout(): void {
  applyLayout(loadLayout());
}

export const LAYOUT_LABEL: Record<LayoutStyle, string> = {
  komfort: "juuplan-Komfort",
  kompakt: "juuplan-Kompakt",
};
